const resultModal = '#result-summary';
let timerID = 0;
const findAll = (selector) => document.querySelectorAll(selector);
const findOne = (selector) => findAll(selector)[0];
const forEach = (selector, f) => findAll(selector).forEach(f);

const addClass = (selector, className) => {
  forEach(selector, (e) => {
    e.classList.add(className);
  })
};

const disableAll = (selector) => {
  forEach(selector, (e) => e.disabled = true)
};

const toggleVisibility = (selector) => {
  forEach(selector, (e) => {
    const hiddenClass = 'is-hidden';
    e.classList.toggle(hiddenClass);
  })
}

const onClick = (selector, onClickFun) => {
  forEach(selector, (e) => {
    e.addEventListener('click', onClickFun);
  });
};

const startCountdown = () => {
  const countdown = document.getElementById("countdown");
  let minutes = +countdown.dataset.time;
  let targetDate = new Date().getTime() + 60 * minutes * 1000;
  let index = 0;
  return setInterval(function () {
    index = 1;
    let currentDate = new Date().getTime();
    let secondsLeft = (targetDate - currentDate) / 1000;

    hours = parseInt(secondsLeft / 3600);
    secondsLeft = secondsLeft % 3600;
    minutes = parseInt(secondsLeft / 60);
    seconds = parseInt(secondsLeft % 60);

    // format countdown string + set tag value
    // if (active) {
    countdown.innerHTML = `Tempo restante: ${hours}h ${minutes}m ${seconds}s`
    if (hours + minutes + seconds == 0) {
      finishExam(true);
    }
  }, 1000 * index);
};

const calculateScore = () => {
  let correct = 0;
  let total = 0;
  forEach('section.question-section', (q) => {
    total++;
    let label = q.querySelector('label')
    let correctAnswer = q.querySelector("input[data-correct='1']");
    let checkedAnswer = q.querySelector('input:checked')
    if (correctAnswer === null) {
      return
    }
    if (correctAnswer == checkedAnswer) {
      correct++;
    }
    correctAnswer.previousElementSibling.classList.remove('is-invisible');
    if (checkedAnswer) {
      checkedAnswer.previousElementSibling.classList.remove('is-invisible');
    }
  });

  return {total: total, correct: correct};
};

const toggleModal = (id) => {
  findOne(id).classList.toggle('is-active');
  findOne('html').classList.toggle('is-clipped');
};

const finishExam = (timeExpired = false) => {
  window.scrollTo(0, 0);
  let {total, correct} = calculateScore();
  if (timeExpired) {
    toggleVisibility('#times-up-banner, #exam-finished-banner');
  }

  disableAll('input[type="radio"]')

  findOne('#correct-number').innerHTML = correct;
  findOne('#wrong-number').innerHTML = total - correct;
  percentage = ((correct / total) * 100).toFixed(2);
  findOne('#percentage').innerText = percentage;
  toggleVisibility(percentage < 50 ? '#failed-banner' : '#success-banner')
  toggleVisibility('.explanation');

  window.clearInterval(timerID);
  toggleModal(resultModal);

  toggleVisibility('#finish');
};

const startExam = () => {
  toggleVisibility('#instruction-box, #exam-box');
  timerID = startCountdown();
  onClick('#finish', (e) => finishExam(false));
  onClick('#close-result', () => toggleModal(resultModal))
}

onClick('#start', startExam);
